/**
 * File Upload Handler
 * Handles file input changes and updates the display text
 */

document.addEventListener('DOMContentLoaded', function() {
    // Find all file inputs within .file containers
    const fileContainers = document.querySelectorAll('.file');
    
    fileContainers.forEach(container => {
        const fileInput = container.querySelector('input[type="file"]');
        
        if (fileInput) {
            // Store original text
            const fileText = container.querySelector('.file-text');
            
            fileInput.addEventListener('change', function(e) {
                const file = e.target.files[0];
                
                if (file) {
                    // File selected - show file name
                    fileText.textContent = file.name;
                    container.style.color = '#374151'; // Normal text color
                    container.style.fontWeight = '500'; // Medium weight
                } else {
                    // No file selected - restore original text
                    fileText.textContent = originalText;
                    container.style.color = 'rgba(27, 43, 107, 0.4)'; // Placeholder color
                    container.style.fontWeight = 'bold';
                }
            });
        }
    });
});